import apiClient from '../apiClient';
import { UPLOAD_COMMIT_EXCURSION_PRICE_URL } from '../apiUrl';

const uploadMasterExcursionPriceApi = data => {
  return apiClient.post(UPLOAD_COMMIT_EXCURSION_PRICE_URL, data);
};

export default uploadMasterExcursionPriceApi;
